<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'

import SancareOcticon from '../../components/SancareOcticon.vue'

export interface SancareBreadcrumbItem {
  label: string
  to?: RouteLocationRaw | null
}

withDefaults(defineProps<{
  items: SancareBreadcrumbItem[]
}>(), {
  items: () => [],
})
</script>

<template>
  <nav
    class="sancare-breadcrumb p-2"
    aria-label="breadcrumb"
  >
    <ol class="breadcrumb mb-0 align-items-center">
      <li
        v-for="(item, index) in items"
        :key="index"
        class="breadcrumb-item d-inline-flex align-items-center"
        :class="{ 'active': index === items.length - 1 }"
        :aria-current="index === items.length - 1 ? 'page' : undefined"
      >
        <component
          :is="item.to && index !== items.length - 1 ? 'router-link' : 'span'"
          :to="item.to && index !== items.length - 1 ? item.to : undefined"
          class="d-inline-flex align-items-center"
        >
          <sancare-octicon
            v-if="index === 0"
            class="home-icon me-2"
            name="home-fill"
            :width="12"
            :height="12"
          />
          <span>{{ item.label }}</span>
        </component>
      </li>
    </ol>
  </nav>
</template>

<style lang="scss" scoped>
@import '@sancare/typescript-commons/src/assets/styles/variables';

.sancare-breadcrumb {
  // stylelint-disable-next-line custom-property-empty-line-before
  --bs-breadcrumb-divider: '>';

  .breadcrumb-item {
    &.active {
      color: #000000;
    }
  }

  :deep(a) {
    color: $sancare-light-blue;

    &:hover {
      text-decoration: underline;
    }
  }

  :deep(svg) {
    display: block;
    fill: $sancare-dark-grey;
  }

  :deep(.home-icon) {
    fill: #b6c5d5;
  }
}
</style>
